import { fetchGttOrders, fetchOrders } from "../services/kiteService";

export const useOrders = () => {
  const fetchLatestOrders = async () => {
    try {
      const response = await fetchOrders();
      return response;
    } catch (error) {
      console.error("Error fetching orders:", error);
      return [];
    }
  };
  const fetchLatestGttOrders = async () => {
    try {
      const response = await fetchGttOrders();
      return response;
    } catch (error) {
      console.error("Error fetching GTT orders:", error);
      return [];
    }
  };
  return {
    fetchLatestOrders,
    fetchLatestGttOrders,
  };
};
